import Container from "components/base/Container";
import {
  MotionBox as Box,
  staggeredAppear,
  viewAppearDefault,
  scaleOut,
} from "utils/motion";

import ScrollHint from "components/base/ScrollHint";
import Text from "components/base/Text";
import Image from "components/base/Image";
import colors from "styles/colors";

export default function HeroHeader({
  imageSrc,
  alt,
  title,
  titleType,
  subtitle,
  subtitleImg,
  description,
  descriptionType,
  cta,
  textShadow,
  subtitleProps,
  align,
  noScrollHint,
  imageProps,
  minHeight,
  textAlign,
  alignItems,
  noGradient,
  noPadding,
  height,
}) {
  return (
    <Box
      width="100%"
      bg="black.900"
      as="section"
      style={{ overflow: "hidden" }}
    >
      <Box
        height={height || "100vh"}
        minHeight={minHeight || ["500px", "550px", "700px"]}
        position="relative"
        overflowX="hidden"
        overflowY="hidden"
      >
        <Box
          width="100%"
          height="100%"
          initial="scaled"
          position="absolute"
          variants={scaleOut}
          animate="normal"
        >
          <Image
            src={imageSrc}
            height={height || "100vh"}
            alt={alt}
            minHeight={minHeight || ["500px", "550px", "700px"]}
            objectFit="cover"
            {...imageProps}
            style={{ position: "absolute" }}
          />
        </Box>
        <Box
          width="100%"
          height="100%"
          px={[0, null, 20]}
          position="relative"
          bg={
            noGradient
              ? undefined
              : [
                  `linear-gradient(to top, ${colors.black[900]} 30%, transparent 55%)`,
                  null,
                  `linear-gradient(to right, rgba(0,0,0,0.3) 40%, transparent 55%), linear-gradient(to bottom, transparent 85%, ${colors.black[900]} 100%)`,
                ]
          }
        >
          <Container
            position="relative"
            height="100%"
            maxWidth="xl"
            display="flex"
            alignItems={alignItems || [align || "flex-end", null, "center"]}
          >
            <Box
              variants={staggeredAppear}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              width={["100%", null, "100%"]}
              mx="auto"
              alignItems={align}
              textAlign={textAlign || "left"}
              color="white"
              pt={[18, null, 24]}
              pb={noPadding ? [12, null, 0] : [2, null, 0]}
            >
              {subtitle && (
                <Text
                  type="title_md"
                  color="primary"
                  {...subtitleProps}
                  variants={viewAppearDefault}
                  maxWidth={["100%", null, textAlign ? "100%" : "50vw"]}
                >
                  {subtitle}
                </Text>
              )}
              {subtitleImg && subtitleImg}
              <Text
                type={titleType || "headline_md"}
                color="white"
                mb="2"
                variants={viewAppearDefault}
                maxWidth={["100%", null, textAlign ? "100%" : "50vw"]}
                textShadow={textShadow || "0 2px 6px rgba(0, 0, 0, 0.8)"}
              >
                {title}
              </Text>
              {description && (
                <Text
                  type={descriptionType || "p_lg"}
                  color="white"
                  variants={viewAppearDefault}
                  maxWidth={["100%", null, textAlign ? "100%" : "650px"]}
                  textShadow={textShadow || "0 2px 6px rgba(0, 0, 0, 0.8)"}
                >
                  {description}
                </Text>
              )}
              {cta && <Box variants={viewAppearDefault}>{cta}</Box>}
            </Box>
            {!noScrollHint && (
              <ScrollHint
                display={["none", null, "block"]}
                position="absolute"
                bottom={0}
                right={20}
              />
            )}
          </Container>
        </Box>
      </Box>
    </Box>
  );
}
